import React from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { AppBar, Toolbar, Box, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

import { powertrainAtom } from 'atoms/powertrainAtom';
import { sideNavOpenAtom } from 'atoms/sideNavAtom';
import { POWERTRAIN_COLORS } from 'styles/theme';
import { BrandLogo } from './BrandLogo';
import { CalcSetIndicator } from './CalcSetIndicator';
import { CopyJobIndicator } from './CopyJobIndicator';
import { PowertrainToggle } from './PowertrainToggle';
import { HelpMenu } from './HelpMenu';
import { UserMenu } from './UserMenu';

// 上部ツールバー。左=ブランド / 中央=計算セット表示・直近履歴 / 右=powertrain・ユーザーメニュー の3領域。
// 下端に powertrain 差し色バー（BEV=ティール / HEV=パープル）を全幅で表示し、トグルを見なくても
// 現在のモードが直感的に分かるようにする（テーマ非依存の固定色 = 切替トグル・履歴 Chip と同色）。
export const AppHeader: React.FC = () => {
    const powertrain = useAtomValue(powertrainAtom);
    const setSideNavOpen = useSetAtom(sideNavOpenAtom);
    return (
        <AppBar
            position="fixed"
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                borderBottom: `3px solid ${POWERTRAIN_COLORS[powertrain].main}`,
            }}
        >
            <Toolbar sx={{ gap: 1 }}>
                <IconButton
                    color="inherit"
                    edge="start"
                    aria-label="サイドナビの開閉"
                    onClick={() => setSideNavOpen((open) => !open)}
                >
                    <MenuIcon />
                </IconButton>
                <BrandLogo />
                <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', minWidth: 0 }}>
                    <CalcSetIndicator />
                </Box>
                <CopyJobIndicator />
                <PowertrainToggle />
                <HelpMenu />
                <UserMenu />
            </Toolbar>
        </AppBar>
    );
};
